import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from "src/environments/environment";
import { ProductService } from '../../shared/services/product.service';
import { SideBarSummaryCartComponent } from '../../shared/sidebar-summary-cart/sidebar-summary-cart.component';
import { SideNavBarService } from '../../shared/services/sidenavbar.service';
import { Cart1Service } from '../../shared/services/cart1.service';
import { ConfigService } from '../../shared/services/config.service';
import { AutoshipConfigurationService } from '../../shared/services/autoshipConfiguration.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { REWARDSTORE, MARKETPLACESTORE } from 'src/app/constant';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {
  productdetails: any;
  product: any;
  env: any;

  showProducts: boolean;
  _screenSize: any;
  public config: SwiperConfigInterface = {};
  
  // Loading state
  isLoading: boolean = true;
  loadingError: boolean = false;
  
  // New properties for the updated design
  quantity: number = 1;
  currentMainImage: string = '';
  quantityDropdownOpen: boolean = false;
  
  // Video properties
  currentVideo: string = '';
  isVideoPlaying: boolean = false;
  
  // All products use the same quantity selector
  get needsQuantitySelector(): boolean {
    return true; // All products get quantity selector
  }

  // All products use package options
  get isPackageProduct(): boolean {
    return true; // All products use package options
  }

  get packageOptions(): {label: string, value: number}[] {
    // All products get the same options
    return [
      { label: 'Single', value: 1 },
      { label: '3pk', value: 3 },
      { label: '6pk', value: 6 },
      { label: '24pk', value: 24 }
    ];
  }

  get currentOptions(): any[] {
    return this.packageOptions;
  }

  // Product benefits data
  productBenefits: any[] = [
    {
      title: "Feel Energized",
      description: "every morning with our Metabology AM to kickstart your metabolism.",
      type: 'empire'
    },
    {
      title: "Rest and Recharge",
      description: "at night with Metabology PM for a balanced, restorative sleep.",
      type: 'movement'
    },
    {
      title: "Stay Balanced and Focused",
      description: "with Metabology Omega, providing essential support for heart, mind, and metabolism.",
      type: 'purpose'
    },
    {
      title: "Glow with Confidence",
      description: "through innovative skincare that brings out your natural radiance.",
      type: 'future'
    }
  ];

  // Product reviews data - will be populated based on product
  productReviews: any[] = [];

  // Scrolling banner data
  scrollContent: any[] = [];

  // FAQ data - will be populated based on product
  faqData: any[] = [];

  get selectedOption(): string {
    const option = this.packageOptions.find(opt => opt.value === this.quantity);
    return option ? option.label : 'Single';
  }

  // Get product variant for background color
  getProductVariant(): string {
    // Use a default variant for all products
    return 'green';
  }

  // Get variant color for styling
  getVariantColor(variant: string): string {
    const variantColors = {
      green: '#677240',
      yellow: '#F09F53',
      orange: '#F18021'
    };
    return variantColors[variant as keyof typeof variantColors] || '#677240';
  }

  // Get variant background color for cards
  getVariantBackgroundColor(variant: string): string {
    const variantBackgrounds = {
      green: 'rgba(103, 114, 64, 0.1)',
      yellow: 'rgba(240, 159, 83, 0.1)',
      orange: 'rgba(243, 236, 218, 0.6)'
    };
    return variantBackgrounds[variant as keyof typeof variantBackgrounds] || 'rgba(103, 114, 64, 0.1)';
  }

  // Get variant border color for cards
  getVariantBorderColor(variant: string): string {
    // Use lighter border color for all variants
    return '#a7c0a5';
  }

  // Method to get product-specific reviews
  getProductReviews(productName: string): any[] {
    const productNameLower = productName?.toLowerCase() || '';
    
    // Define reviews for each product
    const allReviews = {
      'metabology matrix': [
        {
          text: "This complete set has transformed my daily routine. The combination of AM and PM products keeps me energized all day and helps me sleep better at night.",
          customer: "Alex K."
        },
        {
          text: "The Matrix set is incredible! I've noticed significant improvements in my metabolism and overall energy levels since starting this regimen.",
          customer: "Maria S."
        },
        {
          text: "Best investment in my health. The synergistic effect of all these products together is remarkable. Highly recommend!",
          customer: "David R."
        },
        {
          text: "I was skeptical at first, but the Matrix set has exceeded all my expectations. My energy and focus have never been better.",
          customer: "Lisa T."
        }
      ],
      'metabology ω3': [
        {
          text: "The omega-3 boost is incredible! My mental clarity has improved dramatically and my workout recovery is much faster.",
          customer: "Taylor B."
        },
        {
          text: "I've tried many omega-3 supplements, but this one is by far the best. The quality and results are outstanding.",
          customer: "Jordan M."
        },
        {
          text: "My heart health markers have improved significantly since taking this. The science behind it really works.",
          customer: "Chris L."
        },
        {
          text: "This has become an essential part of my daily routine. The cognitive benefits are noticeable within weeks.",
          customer: "Emma W."
        }
      ],
      'metabology lean': [
        {
          text: "The thermogenic support is amazing! I've finally achieved the lean physique I've been working toward for years.",
          customer: "Ryan P."
        },
        {
          text: "This product gives me the extra boost I need during workouts. My fat burning has increased significantly.",
          customer: "Natalie H."
        },
        {
          text: "Combined with my diet and exercise, this has helped me reach my fitness goals faster than ever before.",
          customer: "Kevin F."
        },
        {
          text: "The energy boost is incredible and it helps me stay focused on my health goals throughout the day.",
          customer: "Sophie G."
        }
      ],
      'photonic activator': [
        {
          text: "This activator has optimized my entire wellness routine. I feel energized and recharged throughout the day.",
          customer: "Marcus D."
        },
        {
          text: "The photonic technology really works! My metabolism feels more efficient and I have sustained energy.",
          customer: "Zoe K."
        },
        {
          text: "This product has become my secret weapon for maintaining peak performance and vitality.",
          customer: "Brandon T."
        },
        {
          text: "I love how this supports my metabolism all day long. The results are consistent and impressive.",
          customer: "Amanda R."
        }
      ],
      'metabology am': [
        {
          text: "This morning kickstart is exactly what I needed! I feel energized and focused throughout the entire day.",
          customer: "Sarah M."
        },
        {
          text: "The AM formula has transformed my mornings. I wake up feeling ready to take on anything.",
          customer: "Mike J."
        },
        {
          text: "Perfect way to start my day. The steady energy and focus help me be more productive than ever.",
          customer: "Jessica L."
        },
        {
          text: "This has become my essential morning ritual. The metabolic support is incredible.",
          customer: "Tom W."
        }
      ],
      'metabology pm': [
        {
          text: "The quality of my sleep has improved so much since starting this. I wake up feeling refreshed and ready to tackle anything.",
          customer: "Michael R."
        },
        {
          text: "This PM formula helps me settle into a restful night while supporting my metabolism. Love it!",
          customer: "Rachel K."
        },
        {
          text: "I've struggled with sleep for years, but this product has been a game-changer for my rest quality.",
          customer: "Daniel S."
        },
        {
          text: "The perfect way to wind down and prepare for restorative sleep. My recovery has improved dramatically.",
          customer: "Hannah M."
        }
      ],
      'metabology am/pm': [
        {
          text: "This set is perfect for optimizing my daily rhythm. The 24/7 metabolic support is incredible.",
          customer: "Laura P."
        },
        {
          text: "The AM+PM combination has transformed my energy levels and sleep quality. Highly recommend!",
          customer: "James T."
        },
        {
          text: "This set provides the perfect balance of energy and recovery. My daily performance has never been better.",
          customer: "Catherine L."
        },
        {
          text: "The round-the-clock support is exactly what I needed. This set has become essential to my routine.",
          customer: "Robert K."
        }
      ],
      'rose gold elixir': [
        {
          text: "My skin has never looked better. The natural ingredients really make a difference in my overall complexion and confidence.",
          customer: "Jennifer L."
        },
        {
          text: "This elixir delivers radiance and rejuvenation with every application. My skin feels amazing!",
          customer: "Victoria S."
        },
        {
          text: "The Rose Gold Elixir has become my secret to glowing skin. The results are truly transformative.",
          customer: "Isabella M."
        },
        {
          text: "This beauty ritual has elevated my skincare routine. My skin looks and feels more radiant than ever.",
          customer: "Olivia R."
        }
      ],
      'charcoal cleanser': [
        {
          text: "This gentle yet powerful cleanser has transformed my skincare routine. My skin feels refreshed and renewed.",
          customer: "Grace T."
        },
        {
          text: "The purifying charcoal formula is amazing! My skin feels clean and balanced after every use.",
          customer: "Maya K."
        },
        {
          text: "This cleanser has become my go-to for a refreshing ritual of renewal. The results are consistent.",
          customer: "Ava S."
        },
        {
          text: "I love how gentle yet effective this cleanser is. It's perfect for my daily cleansing routine.",
          customer: "Chloe L."
        }
      ],
      'beauty collection': [
        {
          text: "This complete beauty collection has elevated my entire skincare routine. The results are incredible!",
          customer: "Sofia M."
        },
        {
          text: "The combination of cleanser and elixir has transformed my skin. I feel more confident than ever.",
          customer: "Luna R."
        },
        {
          text: "This collection delivers everything I need for radiant, healthy skin. Highly recommend!",
          customer: "Aria T."
        },
        {
          text: "The Beauty Collection has become my essential ritual. My skin has never looked better.",
          customer: "Nova K."
        }
      ]
    };

    // Check AM/PM set first so combined product gets set reviews (not AM-only or PM-only)
    if (productNameLower.includes('am/pm') || productNameLower.includes('am pm set') || productNameLower.includes('ampm set') || (productNameLower.includes('am') && productNameLower.includes('pm') && productNameLower.includes('set'))) {
      if (allReviews['metabology am/pm']) return allReviews['metabology am/pm'];
    }

    // Try to find matching reviews (more specific keys checked first via iteration order)
    for (const [productKey, reviews] of Object.entries(allReviews)) {
      if (productNameLower.includes(productKey) || productKey.includes(productNameLower)) {
        return reviews;
      }
    }

    // Try matching by key terms (check am/pm before am or pm so set gets set content)
    const keyTerms = {
      'matrix': 'metabology matrix',
      'ω3': 'metabology ω3',
      'omega': 'metabology ω3',
      'lean': 'metabology lean',
      'photonic': 'photonic activator',
      'activator': 'photonic activator',
      'am': 'metabology am',
      'pm': 'metabology pm',
      'rose gold': 'rose gold elixir',
      'elixir': 'rose gold elixir',
      'charcoal': 'charcoal cleanser',
      'cleanser': 'charcoal cleanser',
      'beauty collection': 'beauty collection'
    };

    for (const [term, productKey] of Object.entries(keyTerms)) {
      if (productNameLower.includes(term)) {
        return allReviews[productKey] || this.getDefaultReviews();
      }
    }

    // Return default reviews if no match found
    return this.getDefaultReviews();
  }

  // Default reviews for products not specifically matched
  getDefaultReviews(): any[] {
    return [
      {
        text: "This product has exceeded my expectations. The quality and results are outstanding.",
        customer: "Alex K."
      },
      {
        text: "I've noticed significant improvements since starting this product. Highly recommend!",
        customer: "Maria S."
      },
      {
        text: "The results are consistent and impressive. This has become essential to my routine.",
        customer: "David R."
      },
      {
        text: "I love the quality and effectiveness of this product. It's made a real difference.",
        customer: "Lisa T."
      }
    ];
  }

  // Google Drive video IDs mapped by product
  private getGoogleDriveVideoId(productName: string): string {
    const productNameLower = productName?.toLowerCase() || '';

    // Check AM/PM set first
    if (productNameLower.includes('am/pm') || productNameLower.includes('am pm set') || productNameLower.includes('ampm set') || (productNameLower.includes('am') && productNameLower.includes('pm') && productNameLower.includes('set'))) {
      return '1eXeBuSXEkRXtMzINMcQN7_c4hTOXJRc1';
    }

    if (productNameLower.includes('activator')) return '1gJbp20Biz8_bblq0Svyh64zKl3RYWvI7';
    if (productNameLower.includes('lean')) return '10YX8Cr9gVne1IGFDCSYLyjnTKntW38PC';
    if (productNameLower.includes('rose gold') || productNameLower.includes('elixir')) return '1EqB6GyPp5U_Au1tU7Dd8YODAWKPuvQND';
    if (productNameLower.includes('charcoal') || productNameLower.includes('cleanser')) return '1EqB6GyPp5U_Au1tU7Dd8YODAWKPuvQND';
    if (productNameLower.includes('beauty')) return '1EqB6GyPp5U_Au1tU7Dd8YODAWKPuvQND';

    return '';
  }

  // Get all Google Drive video IDs for a product (some products have multiple)
  getProductVideoIds(productName: string): string[] {
    const productNameLower = productName?.toLowerCase() || '';

    // Beauty Collection / Beauty Matrix Pack gets 2 videos
    if (productNameLower.includes('beauty collection') || productNameLower.includes('beauty')) {
      if (this.isBeautyCollection()) {
        return ['1EqB6GyPp5U_Au1tU7Dd8YODAWKPuvQND', '1DVtTY1--F3_FmNye_5a1aAF9JuvQTzXw'];
      }
    }

    const id = this.getGoogleDriveVideoId(productName);
    return id ? [id] : [];
  }

  // Method to get product video as Google Drive embed URL
  getProductVideo(productName: string): string {
    const id = this.getGoogleDriveVideoId(productName);
    return id ? `https://drive.google.com/file/d/${id}/preview` : '';
  }

  // Method to check if product has video
  hasProductVideo(productName: string): boolean {
    return this.getGoogleDriveVideoId(productName) !== '';
  }

  // Method to play video (Google Drive embed)
  playVideo(videoUrl: string): void {
    this.currentVideo = videoUrl;
    this.isVideoPlaying = true;
    this.currentMainImage = '';
  }

  // Play video by Google Drive file ID
  playVideoById(fileId: string): void {
    this.currentVideo = `https://drive.google.com/file/d/${fileId}/preview`;
    this.isVideoPlaying = true;
    this.currentMainImage = '';
  }

  // Play video by Vimeo video ID
  playVimeoVideo(vimeoId: string): void {
    this.currentVideo = `https://player.vimeo.com/video/${vimeoId}`;
    this.isVideoPlaying = true;
    this.currentMainImage = '';
  }

  // Method to stop video and return to image
  stopVideo(): void {
    this.currentVideo = '';
    this.isVideoPlaying = false;
    this.currentMainImage = this.product?.ImageUrl;
  }

  // Check if product has custom toggle boxes (hides generic thumbnail section)
  hasCustomToggleBoxes(): boolean {
    return this.isPhotonicActivator() || this.isMetabologyAM() || this.isMetabologyLean() ||
           this.isMetabologyOmega() || this.isPurifyingCharcoalCleanser() || this.isRoseGoldElixir() ||
           this.isBeautyCollection() || this.isPM() || this.isAMPMSet() || this.isMetabologyMatrix();
  }

  // Method to get product-specific FAQs
  getProductFAQs(productName: string): any[] {
    const productNameLower = productName?.toLowerCase() || '';
    
    // Define FAQs for each product
    const allFAQs = {
      'metabology matrix': [
        {
          question: "What is the Metabology Matrix?",
          answer: "The Metabology Matrix is a full-spectrum metabolic support system designed to energize your body from morning to night. It features five synergistic bioenergetic products—Metabology AM, PM, Ω3, Lean, and the Photonic Activator—each working at the cellular level to help support energy production, healthy weight management, DNA integrity and telomere health, and 24-hour metabolic rhythm. This isn't just a supplement stack—it's a system. Engineered for harmony, the Matrix helps your body stay in flow, adapt to stress, and age with vitality."
        },
        {
          question: "Can I take just one of the products, or do I need the complete system?",
          answer: "You can take any product individually, and you'll still receive targeted benefits. But the real magic happens when they work together. The Metabology Matrix is designed as a unified system—each formula complements the others to amplify results. Think of it like a symphony: every instrument matters, but together they create something unforgettable. For optimal impact, use the whole system as directed. Your metabolism deserves a masterpiece."
        },
        {
          question: "When will I feel results?",
          answer: "Many people report feeling more energized, stable, and focused within seconds of taking the Photonic Activator. Deeper metabolic shifts resulting from the other products—like improved weight management, sleep quality, and cellular resilience—typically unfold over 2 to 4 weeks of consistent use. The longer you stay in rhythm, the more your body harmonizes with the system."
        },
        {
          question: "Is this safe for teens or older adults?",
          answer: "The Metabology Matrix is formulated for adults, but many of its ingredients are safe and beneficial across age groups. Teens and older adults may benefit from specific components, especially when guided by a health care provider. If you're considering the system for someone under 18 or over 70, we recommend consulting a licensed practitioner to personalize the approach."
        },
        {
          question: "Can I combine this with other wellness routines?",
          answer: "Absolutely. The Metabology Matrix is designed to integrate seamlessly with your existing wellness practices—whether that's yoga, breathwork, intermittent fasting, or spiritual rituals. In fact, many users find that the system enhances their ability to stay consistent, grounded, and energized throughout the day."
        }
      ],
      'metabology ω3': [
        {
          question: "What makes Metabology Ω3 different from other omega supplements?",
          answer: "Metabology Ω3 isn't just another fish oil—it's a metabolic catalyst. Each capsule delivers 820mg of total Omega-3s, including 400mg EPA and 300mg DHA, stabilized with Rosemary Extract, Astaxanthin, and a touch of lemon oil to reduce the repeating often associated with omega supplements. What truly sets it apart is our proprietary fraction distillation technology, which preserves purity and potency while minimizing oxidation. Designed to integrate seamlessly into the Metabology Matrix system, Ω3 helps support cellular signaling and membrane integrity, fat metabolism and anti-inflammatory balance, brain clarity and mood regulation, eye health and visual acuity, and telomere and mitochondrial vitality. It's not just about heart health—it's about whole-body metabolic harmony, with a clean finish."
        },
        {
          question: "How many Metabology Ω3 capsules should I take daily?",
          answer: "Take 1 capsule in the morning and 1 capsule in the evening—2 total per day—for optimal results. This timing helps support both daytime energy and nighttime cellular repair, keeping your metabolism in rhythm around the clock."
        },
        {
          question: "Is it safe for vegetarians or vegans?",
          answer: "Metabology Ω3 is derived from marine sources and is not suitable for vegetarians or vegans. However, we're exploring plant-based omega options for future formulations. Stay tuned."
        },
        {
          question: "Does it contain heavy metals or toxins?",
          answer: "No. Metabology Ω3 is purified using advanced fraction distillation technology, which helps remove contaminants like mercury, lead, and PCBs. Every batch is third-party tested for safety, purity, and potency."
        },
        {
          question: "What does Astaxanthin do?",
          answer: "Astaxanthin is a potent antioxidant derived from microalgae. It helps protect cells from oxidative stress, supports skin and eye health, and enhances the stability of omega oils. In Metabology Ω3, it acts as a guardian—preserving the integrity of the formula while supporting your body's resilience."
        },
        {
          question: "What does Rosemary Extract do in Metabology Ω3?",
          answer: "Rosemary Extract plays a dual role in Metabology Ω3—acting as both a stabilizer and a metabolic ally. Rich in antioxidants like carnosic acid and rosmarinic acid, it helps protect the omega oils from oxidation while supporting cellular resilience. Beyond preservation, rosemary may also support cognitive clarity and memory, help modulate inflammation and oxidative stress, enhance circulation and nutrient delivery, and contribute to eye and skin health when paired with Astaxanthin. It's a botanical with brain, body, and beauty benefits—woven into the formula to protect and empower."
        },
        {
          question: "Will it help with mood or brain fog?",
          answer: "Omega-3s—especially DHA—play a key role in brain health, neurotransmitter function, and emotional balance. Many users report improved clarity, focus, and mood when taking Metabology Ω3 consistently. It's brain food with a metabolic twist."
        }
      ],
      'metabology lean': [
        {
          question: "What is Metabology Lean designed to do?",
          answer: "Metabology Lean is a thermogenic metabolic support formula designed to help you achieve a leaner, more energized body. Powered by a revolutionary blend of Tart Cherry Powder (2% Proanthocyanidins), Turmeric Extract (95% Curcuminoids), and Celery Seed Extract (42% 3-n-butylphthalide), it works naturally with your body to boost thermogenesis and fat metabolism, activate brown adipose tissue for increased energy expenditure, reduce inflammation and metabolic stress, and provide antioxidant protection at the cellular level. It's like having a personal trainer for your metabolism—helping you maximize every workout, every healthy choice, and every moment of movement."
        },
        {
          question: "How does Metabology Lean work?",
          answer: "Metabology Lean targets cells at the metabolic level, increasing internal heat and cellular activity. This process helps your body burn more fat, perform more efficiently, and feel better from the inside out. It's not just about weight loss—it's about metabolic vitality."
        },
        {
          question: "What is the recommended dosage for Metabology Lean?",
          answer: "Take 2 capsules daily, ideally in the morning or before physical activity. This timing helps support thermogenesis and metabolic activation when your body is naturally primed for movement and energy output."
        },
        {
          question: "Is it safe for everyday use?",
          answer: "Yes. Metabology Lean is formulated with natural, scientifically backed ingredients and is designed for daily use. As always, consult your health care provider if you have specific sensitivities or medical conditions."
        },
        {
          question: "Will it make me feel jittery or overstimulated?",
          answer: "No. Metabology Lean is stimulant-free and relies on thermogenic botanicals—not synthetic stimulants—to activate metabolism. Most users report feeling energized, focused, and balanced without the crash or jitters."
        },
        {
          question: "Can I take it with other Metabology products?",
          answer: "Absolutely. Metabology Lean is designed to work in harmony with the complete Metabology Matrix system—including AM, PM, Ω3, and the Photonic Activator. Together, they create a 24-hour rhythm of metabolic support."
        }
      ],
      'photonic activator': [
        {
          question: "What is the Photonic Activator?",
          answer: "The Photonic Activator is a liquid bioenergetic formula designed to boost cellular communication and energy flow. When mixed with water or your favorite drink, it provides targeted photonic programming—light-encoded instructions that help activate metabolic pathways, support mitochondrial function, and improve nutrient absorption. Additionally, the formula contains trace electrolytes that act as conductive messengers, helping your cells interpret and respond to the photonic signals with clarity. Think of it as a spark plug in liquid form—igniting vitality from the inside out, one sip at a time."
        },
        {
          question: "What makes it different from other supplements?",
          answer: "Most supplements nourish the body. The Photonic Activator communicates with it. The electrolytes act as conductive messengers, helping transmit the metabolic instructions encoded in the formula's photonic signature. It's not just nutrition—it's intelligent activation."
        },
        {
          question: "What do the 84 electrolytes actually do?",
          answer: "These electrolytes form a bioenergetic bridge between the formula's light-based programming and your cellular response. They help facilitate metabolic signaling, support hydration, and enhance your body's ability to interpret and integrate the formula's instructions. Think of them as translators—turning light into action."
        },
        {
          question: "How do I use the Photonic Activator?",
          answer: "Mix one serving with water, juice, or your favorite beverage—ideally every four hours or so to maintain the peak performance your Metabology Matrix routine is designed to support. Its rapid response is designed to fit seamlessly into your daily rhythm."
        },
        {
          question: "Is it safe for all ages and diets?",
          answer: "The Photonic Activator is formulated to be gentle, bioavailable, and compatible with most dietary lifestyles. It's free from common allergens and designed for adult use. Younger individuals may benefit under the guidance of a health care provider—especially when supporting cognitive clarity, focus, and metabolic balance during key developmental stages."
        },
        {
          question: "What does it feel like?",
          answer: "Most users report a subtle lift in energy, clarity, and focus—like a gentle cellular 'wake-up call.' Some describe it as feeling more aligned, hydrated, or attuned to their body's natural rhythm. It's a quiet spark with a powerful ripple."
        }
      ],
      'metabology am': [
        {
          question: "When should I take Metabology AM?",
          answer: "Take 2 capsules in the morning—ideally within 30 minutes of waking—to kickstart your metabolism and energize your day. Metabology AM is designed to align with your body's natural circadian rhythm, helping you rise with clarity, focus, and metabolic momentum."
        },
        {
          question: "Does Metabology AM contain caffeine?",
          answer: "Yes. Metabology AM contains natural caffeine sourced from Green Tea Leaf Extract (VegiSURGE®) and Guarana Seed Extract. These plant-based energizers help support alertness, fat metabolism, and cellular activation—without the crash often linked to synthetic stimulants. The natural buffers found in these whole ingredients help modulate absorption and deliver a more balanced, sustained lift."
        },
        {
          question: "Can I take it with breakfast?",
          answer: "Absolutely. Metabology AM can be taken with or without food, depending on your preference. Many users enjoy pairing it with a light breakfast to support digestion and sustained energy throughout the morning."
        },
        {
          question: "Is it safe for sensitive stomachs?",
          answer: "Yes. Metabology AM is designed to be gentle and bioavailable. If you have a sensitive stomach, try taking it with food or a smoothie. As always, consult your health care provider if you have specific sensitivities or medical conditions."
        },
        {
          question: "How does it compare to traditional energy supplements?",
          answer: "Unlike many energy supplements that rely on synthetic stimulants or sugar spikes, Metabology AM uses plant-based ingredients to support cellular energy, metabolic activation, and mental clarity. It's not just a boost—it's a bioenergetic upgrade."
        },
        {
          question: "Will it affect my sleep?",
          answer: "Metabology AM is formulated for morning use and contains natural caffeine, so it's best taken early in the day. When used as directed, it supports daytime energy without interfering with nighttime rest—especially when paired with Metabology PM to help wind down."
        },
        {
          question: "Can I take Metabology AM if I'm sensitive to caffeine?",
          answer: "If you're caffeine-sensitive, we recommend starting with one capsule and observing how your body responds. Metabology AM uses natural caffeine sources—like Green Tea Leaf Extract (VegiSURGE®) and Guarana Seed Extract—which are buffered by whole-plant compounds to help deliver a smoother, more sustained lift. You can also take it with food to soften the effect."
        },
        {
          question: "How does VegiSURGE® differ from regular green tea extract?",
          answer: "VegiSURGE® is a patented form of Green Tea Leaf Extract standardized for natural caffeine content and purity. Unlike generic green tea extracts, VegiSURGE® is designed to deliver clean, plant-based energy with minimal bitterness and maximum bioavailability. It's part of what makes Metabology AM both effective and gentle."
        }
      ],
      'metabology pm': [
        {
          question: "Will Metabology PM interfere with my sleep?",
          answer: "Not at all. Metabology PM is specifically formulated to support nighttime metabolism while promoting deep relaxation and restorative sleep. It contains sleep-supporting ingredients like Melatonin (4mg) and L-Theanine, which help ease the mind, calm the nervous system, and gently guide the body into rest. Emerging research also suggests that L-Theanine may support the body's natural detoxification pathways—including the elimination of spike protein fragments—making it a valuable ally for cellular recovery and immune resilience."
        },
        {
          question: "What time should I take Metabology PM?",
          answer: "Take 2 capsules in the evening, ideally 30 to 60 minutes before bedtime. Metabology PM is designed to align with your body's natural wind-down rhythm—helping you transition from alertness to rest while supporting cellular repair and overnight metabolic function."
        },
        {
          question: "Will I feel groggy in the morning?",
          answer: "Most users wake up feeling refreshed and clear-headed. Metabology PM is designed to support natural sleep cycles—not override them. Its ingredients work gently with your body, helping you fall asleep more easily and wake up with energy and focus."
        },
        {
          question: "Can I take it with other nighttime supplements or medications?",
          answer: "Metabology PM is formulated to be gentle and compatible with most wellness routines. However, if you're taking prescription sleep aids, sedatives, or other medications, we recommend consulting your health care provider to ensure safe and effective integration."
        },
        {
          question: "Is it habit-forming?",
          answer: "No. Metabology PM is non-habit-forming and free from synthetic sedatives. It supports your body's natural sleep architecture without dependency—making it safe for long-term use as part of your nightly wellness ritual."
        },
        {
          question: "What makes it different from other sleep supplements?",
          answer: "Metabology PM doesn't just help you sleep—it helps your body work while you rest. Its unique blend supports mitochondrial repair, metabolic recalibration, and cellular detoxification during your deepest sleep cycles. It's not just rest—it's restoration."
        }
      ],
      'metabology am/pm': [
        {
          question: "Why are Metabology AM and PM considered the core of the Matrix?",
          answer: "Metabology AM and PM are the rhythmic anchors of the Metabology Matrix. They're designed to bookend your day—activating metabolism in the morning and supporting cellular repair at night. Together, they help establish a circadian pattern that's essential to metabolic health, hormonal balance, and emotional resilience."
        },
        {
          question: "What is the Metabology philosophy of circadian rhythm?",
          answer: "Metabology honors the body's natural rhythm—its rise, peak, and restoration. By aligning supplementation with your biological clock, we support morning activation (energy, focus, thermogenesis), evening restoration (sleep, detoxification, cellular repair), and 24-hour metabolic flow (consistent support without overstimulation). This rhythm isn't just biological—it's poetic. It's the pulse of vitality, the breath of balance, and the heartbeat of transformation."
        },
        {
          question: "What does Metabology AM do?",
          answer: "Metabology AM is your morning ignition. With natural caffeine from Green Tea (VegiSURGE®) and Guarana, plus metabolic activators like Chromium, Green Coffee Bean, and Bitter Orange, it helps boost energy and fat metabolism, enhance focus and mood, and support blood sugar balance and thermogenesis. It's designed to energize without overstimulating—setting the tone for a productive, vibrant day."
        },
        {
          question: "What does Metabology PM do?",
          answer: "Metabology PM is your evening exhale. With Melatonin (4mg), L-Theanine, and calming botanicals, it helps promote restful sleep and relaxation, support nighttime metabolic repair, and aid detoxification and cellular renewal. It's not just sleep support—it's metabolic restoration while you dream."
        },
        {
          question: "Can I take AM and PM together?",
          answer: "They're designed to be taken separately—AM in the morning, PM in the evening—to align with your body's natural rhythm. Together, they form a 24-hour cycle of support that's central to the Metabology philosophy."
        },
        {
          question: "What happens when I follow this rhythm consistently?",
          answer: "Many users report more stable energy and mood, better sleep quality and recovery, improved metabolic efficiency, and a deeper sense of balance and flow. It's not just about supplements—it's about syncing with your body's wisdom."
        }
      ],
      'rose gold elixir': [
        {
          question: "What is the Rose Gold Elixir designed to do?",
          answer: "The Rose Gold Elixir is a luxurious, fast-absorbing facial oil formulated to hydrate, illuminate, and restore skin vitality. Infused with 24K gold, rosehip seed oil, and botanical extracts, it helps soften fine lines, boost radiance, and create a luminous canvas for your day or night routine."
        },
        {
          question: "Can I use it under makeup?",
          answer: "Yes! The Elixir doubles as a glow-enhancing primer. Just a few drops before foundation helps smooth texture and add a subtle, dewy finish—without greasiness."
        },
        {
          question: "Is it suitable for sensitive skin?",
          answer: "Absolutely. The formula is gentle and non-comedogenic, making it suitable for most skin types—including sensitive and acne-prone. As always, patch test if you're unsure."
        },
        {
          question: "When should I apply it?",
          answer: "Use it morning and evening after cleansing and before heavier creams. It's especially powerful when paired with facial massage or gua sha rituals."
        },
        {
          question: "Does it contain synthetic fragrance or parabens?",
          answer: "No. The Rose Gold Elixir is free from synthetic fragrance, parabens, and harsh preservatives. It's clean beauty with a golden soul."
        }
      ],
      'charcoal cleanser': [
        {
          question: "What does the Purifying Charcoal Cleanser do?",
          answer: "This gentle yet effective cleanser uses activated charcoal, aloe vera, and botanical extracts to draw out impurities, balance oil production, and soothe the skin. It's designed to leave your face feeling clean, calm, and refreshed—without stripping moisture."
        },
        {
          question: "Is it safe for daily use?",
          answer: "Yes. The formula is pH-balanced and gentle enough for daily cleansing, even for sensitive or breakout-prone skin."
        },
        {
          question: "Will it help with acne or clogged pores?",
          answer: "The activated charcoal helps detoxify and unclog pores, while aloe and botanicals calm inflammation. It's a great choice for those managing acne, blackheads, or oily skin."
        },
        {
          question: "Can I use it with other skincare products?",
          answer: "Definitely. It's designed to be the first step in your skincare ritual—clearing the way for serums, moisturizers, and treatments to absorb more effectively."
        },
        {
          question: "Does it contain sulfates or synthetic dyes?",
          answer: "No. The Purifying Charcoal Cleanser is free from sulfates, synthetic dyes, and harsh surfactants. It's clean, conscious, and crafted for skin harmony."
        }
      ],
      'beauty collection': [
        {
          question: "What is included in the Beauty Collection?",
          answer: "The Beauty Collection includes Purifying Charcoal Cleanser (4oz) and Rose Gold Elixir (1oz), creating a complete two-step skincare system that delivers deep cleansing and radiant nourishment in one perfect pairing."
        },
        {
          question: "How do the Beauty Collection products work together?",
          answer: "The Charcoal Cleanser creates the ideal canvas by drawing out impurities and balancing your skin, while Rose Gold Elixir delivers luxury-level hydration and illumination. Together, they form a complete skincare system."
        },
        {
          question: "What are the complete benefits of the Beauty Collection?",
          answer: "Benefits include deep detoxification, soothing hydration, balanced skin, gentle exfoliation, illuminating radiance, deep hydration, plumped skin texture, enhanced firmness, brightened complexion, environmental protection, overnight renewal, and calming aromatherapy."
        },
        {
          question: "How do I use the Beauty Collection for best results?",
          answer: "Start with Purifying Charcoal Cleanser to create the perfect canvas, then follow with Rose Gold Elixir to nourish and illuminate. This creates a complete skincare ritual that transforms your routine into a luxury experience."
        },
        {
          question: "What makes the Beauty Collection unique?",
          answer: "The Beauty Collection represents the perfect marriage of cutting-edge skincare science and natural botanical excellence, delivering spa-quality facial treatment results in your daily routine with visible, lasting results."
        },
        {
          question: "Do you offer a money-back guarantee?",
          answer: "Yes! We offer a 30-day money-back happiness guarantee if dissatisfied with any product. For help, contact Support at hello@tangerine.fun."
        }
      ],
      'general': [
        {
          question: "Are there any side effects I should be aware of?",
          answer: "Each product in the Metabology Matrix is crafted with natural, bioavailable ingredients. While most users experience only positive shifts—like increased energy, clarity, and metabolic flow—each body is unique. These products have not been evaluated by the FDA, so we always recommend consulting your health care provider before starting, especially if you have existing medical conditions or are taking medications."
        },
        {
          question: "Can I take these products long-term?",
          answer: "Yes. The Metabology Matrix is designed for ongoing metabolic support—helping your body stay in rhythm, adapt to stress, and age with vitality. That said, your health journey is personal. We encourage regular check-ins with your health care provider to ensure your supplement routine continues to align with your evolving needs and goals."
        },
        {
          question: "Do you offer a money-back guarantee?",
          answer: "Absolutely. We offer a 30-day happiness guarantee. If you're not satisfied with any product for any reason, just reach out to our Customer Care Team at hello@tangerine.fun or call us at (855) 525 – 2025. We're here to support your journey—and your joy."
        },
        {
          question: "Can I take these supplements together?",
          answer: "Yes. Each product in the Metabology Matrix is designed to work synergistically—supporting your metabolism across morning, evening, and cellular repair cycles. You can take them together or stagger them throughout the day based on your routine."
        },
        {
          question: "Are these supplements safe for teens or older adults?",
          answer: "The formulas are designed for adult use. If you're considering them for a teen or older adult, we recommend consulting a health care provider to ensure the ingredients and dosages are appropriate for their age and health status."
        },
        {
          question: "Do I need to cycle off these supplements?",
          answer: "Not necessarily. The Metabology Matrix is built for sustained use. However, some users choose to take short breaks or adjust their dosage seasonally. Listen to your body, and consult your health care provider if you're unsure."
        }
      ]
    };

    // Check AM/PM set first so combined product gets set FAQs (not AM-only or PM-only)
    if (productNameLower.includes('am/pm') || productNameLower.includes('am pm set') || productNameLower.includes('ampm set') || (productNameLower.includes('am') && productNameLower.includes('pm') && productNameLower.includes('set'))) {
      if (allFAQs['metabology am/pm']) {
        const generalFAQs = allFAQs['general'] || [];
        return [...allFAQs['metabology am/pm'], ...generalFAQs];
      }
    }

    // Try to find matching FAQs
    let productFAQs = [];
    for (const [productKey, faqs] of Object.entries(allFAQs)) {
      if (productNameLower.includes(productKey) || productKey.includes(productNameLower)) {
        productFAQs = faqs;
        break;
      }
    }

    // Try matching by key terms
    const keyTerms = {
      'matrix': 'metabology matrix',
      'ω3': 'metabology ω3',
      'omega': 'metabology ω3',
      'lean': 'metabology lean',
      'photonic': 'photonic activator',
      'activator': 'photonic activator',
      'am': 'metabology am',
      'pm': 'metabology pm',
      'rose gold': 'rose gold elixir',
      'elixir': 'rose gold elixir',
      'charcoal': 'charcoal cleanser',
      'cleanser': 'charcoal cleanser',
      'beauty collection': 'beauty collection'
    };

    if (productFAQs.length === 0) {
    for (const [term, productKey] of Object.entries(keyTerms)) {
      if (productNameLower.includes(term)) {
          productFAQs = allFAQs[productKey] || [];
          break;
        }
      }
    }

    // Combine product-specific FAQs with general FAQs
    const generalFAQs = allFAQs['general'] || [];
    const combinedFAQs = [...productFAQs, ...generalFAQs];

    // Return combined FAQs or default if no match found
    return combinedFAQs.length > 0 ? combinedFAQs : this.getDefaultFAQs();
  }

  // Default FAQs for products not specifically matched
  getDefaultFAQs(): any[] {
    return [
      {
        question: "How should I take this product?",
        answer: "Follow the recommended dosage on the product label. Take with food unless otherwise directed, and consult with your healthcare provider for personalized guidance."
      },
      {
        question: "When will I see results?",
        answer: "Results vary by individual and product. Many users notice benefits within the first few weeks of consistent use. Optimal results typically develop over 4-6 weeks."
      },
      {
        question: "Can I take this with other supplements?",
        answer: "Yes, this product can generally be safely combined with other supplements. However, it's always best to consult with your healthcare provider about supplement interactions."
      },
      {
        question: "Is this suitable for my lifestyle?",
        answer: "Our products are designed to fit into various lifestyles and wellness routines. Start with the recommended dosage and adjust as needed for your individual needs."
      },
      {
        question: "Can I take this long-term?",
        answer: "The products are designed for ongoing use as part of your wellness routine. However, consult with your healthcare provider about long-term use based on your individual health needs."
      },
      {
        question: "Do you offer a money-back guarantee?",
        answer: "Yes! We offer a 30-day money-back happiness guarantee if dissatisfied with any product. For help, contact Support at hello@tangerine.fun."
      }
    ];
  }

  // Format description with proper line breaks
  formatDescription(description: string): string {
    if (!description) return '';
    return description.replace(/\n/g, '<br>');
  }

  // Generate dynamic subtitle based on product
  getProductSubtitle(): string {
    if (!this.product?.ProductName) return 'Premium wellness product designed to enhance your daily routine.';
    
    const productName = this.product.ProductName.toLowerCase();
    
    // Generate product-specific subtitles
    if (productName.includes('metabology')) {
      if (productName.includes('am')) {
        return 'Morning metabolic support to energize your day with steady focus and vitality.';
      } else if (productName.includes('pm')) {
        return 'Evening metabolic support for restful sleep and overnight wellness.';
      } else if (productName.includes('lean')) {
        return 'Thermogenic support to help achieve your lean, healthy physique goals.';
      } else if (productName.includes('omega') || productName.includes('ω3')) {
        return 'Essential omega-3 support for heart health, clear thinking, and metabolism.';
      } else if (productName.includes('matrix')) {
        return 'Complete 24/7 metabolic support system for all-day energy and wellness.';
      } else {
        return 'Advanced metabolic support created to help you succeed.';
      }
    } else if (productName.includes('photonic')) {
      return 'Photonic wellness technology to energize, recharge, and optimize your routine.';
    } else if (productName.includes('rose') || productName.includes('elixir')) {
      return 'Luxurious beauty elixir for radiant skin and elevated self-care rituals.';
    } else if (productName.includes('charcoal') || productName.includes('cleanser')) {
      return 'Purifying cleanser that transforms your skincare routine into a refreshing ritual.';
    } else if (productName.includes('beauty collection')) {
      return 'Complete beauty collection designed to bring out your natural radiance.';
    }
    
    // Fallback for other products
    return 'Premium wellness product designed to enhance your daily routine and well-being.';
  }

  


  

  
  testimonialImageUrl = '../../../../assets/images/new/BrainSenseNEW.webp';
  ItemCode: any
  public shipMethod: any = "once";
  public isRewardsStore: boolean = false;
  public isMarketplaceStore: boolean = false;
  autoshipFreq: any;
  public commonData: any;
  
  constructor(
    private productservice: ProductService,
    private router: Router,
    private activateroute: ActivatedRoute,
    private SideNavBarService: SideNavBarService,
    private cartservice: Cart1Service,
    public configService: ConfigService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    private sanitizer: DomSanitizer,
    private userService: UserService
  ) { 
    this.commonData = this.configService.getConfig();
  }

  splitText: string[] = [];
  plainText: string = '';
  
  convertToPlainText(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  // Function to split the plain text at the specified word
  splitByWord(text: string, word: string): string[] {
    const regex = new RegExp(`(${word})`, 'i'); // Keeps the matched word in case you want to use it later
    const parts = text?.split(regex);
  
    if (parts.length > 1) {
      return [parts[0].trim(), parts.slice(1).join('').trim()];
    } else {
      return [text]; // If word not found, return whole text as the first part
    }
  }
  
  productDiscription: any;
  productSuggestions: any;
  productImages: any;
  Specifications: any;
  safeProductDescription: SafeHtml;
  
  retryLoad(): void {
    // Reset loading state and retry
    this.isLoading = true;
    this.loadingError = false;
    
    if (this.ItemCode) {
      this.productservice.getProduct(this.ItemCode).subscribe({
        next: (data) => {
          this.productdetails = data;
          this.product = this.productdetails;
          this.Specifications = this.product?.Specifications;
          this.splitText = this.splitByWord(this.product?.Description, 'SUGGESTED Use:');
          this.productDiscription = this.splitText[0];
          this.safeProductDescription = this.sanitizer.bypassSecurityTrustHtml(
            this.transformDescription(this.productDiscription)
          );
          this.productSuggestions = this.splitText[1];
          if(this.product.Images[1]){
            this.productImages = this.product.Images[1].Path;
          } else {
            this.productImages = '';
          }
          
          // Set initial main image
          this.currentMainImage = this.product?.ImageUrl;
          
          // Initialize quantity for package products
          this.initializeQuantity();
          
          // Load product-specific reviews
          this.productReviews = this.getProductReviews(this.product?.ProductName);
          
          // Load product-specific FAQs
          this.faqData = this.getProductFAQs(this.product?.ProductName);
          
          // Mark loading as complete
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching product:', error);
          this.isLoading = false;
          this.loadingError = true;
        }
      });
    }
  }

  ngOnInit(): void {
    this.env = environment;
    window.scrollTo(0, 0);
    this.autoshipConfigurationService.init();
    this.createScrollContent();
    
    // Determine store context
    const currentStoreId = sessionStorage.getItem('selectedStoreId');
    this.isRewardsStore = currentStoreId === REWARDSTORE;
    this.isMarketplaceStore = currentStoreId === MARKETPLACESTORE;

    // Outside marketplace (rewards or main), force one-time purchase
    if (!this.isMarketplaceStore) {
      this.shipMethod = "once";
    }

    this.activateroute.queryParamMap.subscribe((params) => {
      const productId = params.get('id');  // Get the parameter from URL
      
      if (productId && productId.includes('-id')) {
        const parts = productId.split('-id');
        this.ItemCode = parts[1];  // Convert to number
        
        if(this.ItemCode){
          this.isLoading = true;
          this.loadingError = false;
          
          this.productservice.getProduct(this.ItemCode).subscribe({
            next: (data) => {
              this.productdetails = data;
              this.product = this.productdetails;
              this.Specifications = this.product?.Specifications;
              this.splitText = this.splitByWord(this.product?.Description, 'SUGGESTED Use:');
              this.productDiscription = this.splitText[0];
              this.safeProductDescription = this.sanitizer.bypassSecurityTrustHtml(
                this.transformDescription(this.productDiscription)
              );
              this.productSuggestions = this.splitText[1];
              if(this.product.Images[1]){
                this.productImages = this.product.Images[1].Path;
              } else {
                this.productImages = '';
              }
              
              // Set initial main image
              this.currentMainImage = this.product?.ImageUrl;
              
              // Initialize quantity for package products
              this.initializeQuantity();
              
              // Load product-specific reviews
              this.productReviews = this.getProductReviews(this.product?.ProductName);
              
              // Load product-specific FAQs
              this.faqData = this.getProductFAQs(this.product?.ProductName);
              
              // Mark loading as complete
              this.isLoading = false;
            },
            error: (error) => {
              console.error('Error fetching product:', error); // Debug log
              this.isLoading = false;
              this.loadingError = true;
            }
          });
        } else {
          console.error('No Item Code found in product ID:', productId); // Debug log
        }
      } else {
        console.error('Invalid product ID format:', productId); // Debug log
      }
    });

    this._screenSize = window.innerWidth
    this.showProducts = true;
  }

  // New methods for the updated design
  setPurchaseMethod(method: string): void {
    // Only allow switching in marketplace store; otherwise force one-time
    if (!this.isMarketplaceStore) {
      this.shipMethod = "once";
      return;
    }
    
    this.shipMethod = method;
    if (method === 'subscribe' && this.commonData?.FrequencyTypes?.length > 0) {
      this.autoshipFreq = this.commonData.FrequencyTypes[0]?.ID;
    }
  }

  getCurrentPrice(): number {
    // For subscribe/autoship, use the lower price (AutoshipPrice if available, otherwise Price)
    // For one-time, use the higher price (Price)
    const basePrice = this.shipMethod === 'subscribe' ? 
      (this.product?.AutoshipPrice || this.product?.Price) : 
      this.product?.Price;
    return (basePrice || 0) * this.quantity;
  }

  changeMainImage(image: any): void {
    if (image && image.Path) {
      // Stop video if it's playing
      if (this.isVideoPlaying) {
        this.stopVideo();
      }
      
      // If imageUrl is empty, use the API URL, otherwise use the configured imageUrl
      const baseUrl = this.env?.imageUrl || this.env?.apiUrl || '';
      this.currentMainImage = baseUrl + image.Path;
    }
  }

  // Check if current product is Photonic Activator
  isPhotonicActivator(): boolean {
    return this.product?.ProductName?.toLowerCase().includes('photonic activator') || false;
  }

  // Check if current product is Metabology AM (standalone AM, not AM/PM set)
  isMetabologyAM(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    if (productName.includes('set') || (productName.includes('pm') && productName.includes('am'))) {
      return false; // AM/PM set or combo - use isAMPMSet() section
    }
    return productName.includes('metabology am') ||
           (productName.includes('metabology') && (productName.includes(' am ') || productName.endsWith(' am') || productName.includes(' am') || /\bam\b/.test(productName))) ||
           false;
  }

  // Check if current product is Metabology Lean
  isMetabologyLean(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('metabology lean') || 
           (productName.includes('lean') && !productName.includes('cleanser')) ||
           false;
  }

  // Check if current product is Metabology Omega
  isMetabologyOmega(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('metabology ω3') || 
           productName.includes('metabology omega') ||
           productName.includes('ω3') ||
           productName.includes('omega') ||
           false;
  }

  // Check if current product is Purifying Charcoal Cleanser
  isPurifyingCharcoalCleanser(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('purifying charcoal cleanser') || 
           productName.includes('charcoal cleanser') ||
           (productName.includes('cleanser') && !productName.includes('lean')) ||
           false;
  }

  // Check if current product is Rose Gold Elixir
  isRoseGoldElixir(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('rose gold elixir') || 
           productName.includes('gold elixir') ||
           productName.includes('rose elixir') ||
           false;
  }

  // Check if current product is Beauty Collection
  isBeautyCollection(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('beauty collection') ||
           productName.includes('beauty') ||
           false;
  }

  // Check if current product is PM (standalone PM, not AM/PM set)
  isPM(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    if (productName.includes('set') || (productName.includes('pm') && productName.includes('am'))) {
      return false; // AM/PM set or combo - use isAMPMSet() section
    }
    return (productName.includes('metabology pm') || (productName.includes('metabology') && (productName.includes(' pm ') || productName.endsWith(' pm') || productName.includes(' pm') || /\bpm\b/.test(productName)))) ||
           (productName.includes('pm') && !productName.includes('am')) ||
           (productName.includes('p.m') && !productName.includes('am')) ||
           false;
  }

  // Check if current product is AM PM Set (combined AM+PM product)
  isAMPMSet(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    return productName.includes('am pm set') ||
           productName.includes('am/pm set') ||
           productName.includes('ampm set') ||
           (productName.includes('am') && productName.includes('pm') && productName.includes('set')) ||
           productName.includes('am/pm') ||
           productName.includes('am + pm') ||
           false;
  }

  // Check if current product is Metabology Matrix
  isMetabologyMatrix(): boolean {
    const productName = this.product?.ProductName?.toLowerCase() || '';
    if (productName.includes('beauty')) return false; // Photonic Beauty Matrix uses Beauty Collection boxes instead
    return productName.includes('matrix') || false;
  }

  // Toggle main image for Photonic Activator boxes
  toggleMainImage(imageUrl: string): void {
    if (imageUrl) {
      // Stop video if it's playing
      if (this.isVideoPlaying) {
        this.stopVideo();
      }
      
      // Check if it's a PDF - if so, open in new tab instead of setting as main image
      if (imageUrl.toLowerCase().includes('.pdf')) {
        window.open(imageUrl, '_blank');
        return;
      }
      // Only set as main image if it's an actual image file
      this.currentMainImage = imageUrl;
    }
  }

  incrementQuantity(): void {
    this.quantity++;
  }

  decrementQuantity(): void {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  toggleQuantityDropdown(): void {
    this.quantityDropdownOpen = !this.quantityDropdownOpen;
  }

  selectQuantity(qty: number): void {
    this.quantity = qty;
    this.quantityDropdownOpen = false;
    
    // Force change detection to update the UI immediately
    setTimeout(() => {
      this.quantityDropdownOpen = false;
    }, 0);
  }

  initializeQuantity(): void {
    // Always start with quantity 1 (single bottle)
    this.quantity = 1;
  }

  addToCart(): void {
    if (this.product) {
      // Use the existing cart service with the updated quantity
      const isAutoship = this.shipMethod === 'subscribe';
      
      // Determine if this should be a loyalty order based on customer type
      // Customer Type 1 = "Fun Ambassador" (IBO) - gets loyalty pricing
      const isLoyaltyOrder = this.userService.userServiceModal.customerTypeID === 1;
      
      if (isAutoship) {
        // For autoship, use the original product but preserve the AutoshipPrice field
        const productToAdd = { ...this.product };
        
        // Set AutoshipPrice if not already set, using the same logic as autoship-edit component
        if (!productToAdd.AutoshipPrice && productToAdd.Prices && productToAdd.Prices.length > 0) {
          // Look for autoship price in the Prices array
          const autoshipPrice = productToAdd.Prices.find(price => price.PriceGroup === 3) || productToAdd.Prices[0];
          if (autoshipPrice) {
            productToAdd.AutoshipPrice = autoshipPrice.Price;
          }
        }
        
        // Don't set the price here - let the cart service handle it
        // The cart service will set item.Price = item.AutoshipPrice when isAutoship is true
        
        // Add the product with autoship flag and loyalty order flag
        for (let i = 0; i < this.quantity; i++) {
          this.cartservice.addToCart(
            productToAdd, 
            true, 
            "", 
            true, // isAutoship
            false, 
            false, 
            true, 
            null, 
            null, 
            isLoyaltyOrder // loyaltyOrder - now properly set based on customer type
          );
        }
        
        // Store product for sidebar
        localStorage.setItem("params.item", JSON.stringify(productToAdd));
        this.SideNavBarService.openSidePanel();
      } else {
        // For one-time purchase, use the current product
        const productToAdd = { ...this.product };
        
        // Add multiple items based on quantity
        for (let i = 0; i < this.quantity; i++) {
          this.cartservice.addToCart(
            productToAdd, 
            true, 
            "", 
            false, // isAutoship
            false, 
            false, 
            true, 
            null, 
            null, 
            isLoyaltyOrder // loyaltyOrder - now properly set based on customer type
          );
        }
        
        // Store product for sidebar
        localStorage.setItem("params.item", JSON.stringify(productToAdd));
        this.SideNavBarService.openSidePanel();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = target.closest('.custom-dropdown');
    const dropdownToggle = target.closest('.dropdown-toggle');
    const dropdownOption = target.closest('.dropdown-option');
    
    // Don't close if clicking on dropdown toggle (let toggleQuantityDropdown handle it)
    if (dropdownToggle) {
      return;
    }
    
    // Don't close if clicking on dropdown option (let selectQuantity handle it)
    if (dropdownOption) {
      return;
    }
    
    // Close dropdown if clicking outside
    if (!dropdown && this.quantityDropdownOpen) {
      this.quantityDropdownOpen = false;
    }
  }
  
  windowResize(event: Event): void {
    this._screenSize = window.innerWidth
    if(this._screenSize <= 975) {
      // Handle mobile view
    }
  }
  
  transformDescription(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
  
    const anchors = div.querySelectorAll('a');
    anchors.forEach(a => {
      const href = a.getAttribute('href');
  
      if (!href || href.trim() === '') {
        // No href or empty href — convert to plain text
        const text = document.createTextNode(a.textContent || '');
        a.replaceWith(text);
      } else {
        // Optional: sanitize or force href to open in new tab
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
    });
  
    return div.innerHTML;
  }
  
  ngAfterViewInit(): void {
    this._screenSize = window.innerWidth
    this.config = {
      mousewheel: false,
      observer: true,
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: true,
      breakpoints: {
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 1,
        },
        1280: {
          slidesPerView: 1,
        },
      },
    };
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['shipMethod'] && this.shipMethod === 'subscribe') {
      this.autoshipFreq = this.commonData.FrequencyTypes[0]?.ID; 
    }
  }
  


  // Keep existing methods for backwards compatibility
  sideBarOpen(isAutoship: boolean, loyaltyOrder?: boolean){
    if(isAutoship){
      this.cartservice.addToCart(this.product, true, "", true, false, false, true, null, null, loyaltyOrder);
    } else {
      this.cartservice.addToCart(this.product, true, "", false, false, false, true, null, null, loyaltyOrder);
    }
    localStorage.setItem("params.item", JSON.stringify(this.product));
    this.SideNavBarService.openSidePanel();
  }

  // FAQ toggle method
  toggleFaq(index: number): void {
    // Close all other FAQ items first
    this.faqData.forEach((faq, i) => {
      if (i !== index) {
        faq.isOpen = false;
      }
    });
    
    // Toggle the clicked item
    this.faqData[index].isOpen = !this.faqData[index].isOpen;
  }

  createScrollContent(): void {
    const phrases = [
      "Feel Energized",
      "Juice Life",
      "Boost Metabolism",
      "Stay Balanced and Focused",
      "Rest and Recharge"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  // TrackBy functions for better performance and to prevent double-click issues
  trackByImage(index: number, image: any): any {
    return image.Path || index;
  }

  trackByOption(index: number, option: any): any {
    return option.value || index;
  }

  trackByFrequency(index: number, freq: any): any {
    return freq.ID || index;
  }

  trackByReview(index: number, review: any): any {
    return review.customer || index;
  }

  trackByFeature(index: number, feature: any): any {
    return feature.title || index;
  }

  trackByFaq(index: number, faq: any): any {
    return index;
  }
}
